import { request } from "./http";

export interface Leader {
  trader_id: string;
  display_name: string;
  bio: string | null;
  verified: boolean;
}

export interface TraderProfile extends Leader {
  public: boolean;
  performance_fee_bps: number;
}

export interface Follow {
  id: string;
  leader_trader_id: string;
  leader_display_name: string;
  copy_factor: string;
  max_risk_pct: string;
  max_drawdown_stop_pct: string;
  stopped_at: string | null;
  stop_reason: string | null;
}

export const social = {
  leaders: () => request<Leader[]>("/api/v1/social/leaders"),
  myFollows: () => request<Follow[]>("/api/v1/social/me/follows"),
  follow: (body: {
    leader_trader_id: string;
    copy_factor?: number;
    max_risk_pct?: number;
    max_drawdown_stop_pct?: number;
  }) => request<Follow>("/api/v1/social/follows", { body }),
  unfollow: (id: string) =>
    request<{ id: string; status: string }>(`/api/v1/social/follows/${id}`, {
      method: "DELETE",
    }),
  createProfile: (body: { display_name: string; bio?: string; public?: boolean }) =>
    request<TraderProfile>("/api/v1/social/me/profile", { body }),
  patchProfile: (body: Partial<{ display_name: string; bio: string; public: boolean; performance_fee_bps: number }>) =>
    request<TraderProfile>("/api/v1/social/me/profile", { method: "PATCH", body }),
};
